// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slide-selector[data-v-e24702ea]{max-width:340px;text-align:left}.selector-item[data-v-e24702ea]{background-color:transparent;cursor:pointer;padding:18px}.selector-item.is-active[data-v-e24702ea]{background-color:#f9faf9}.user-avatar[data-v-e24702ea]{margin-bottom:18px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
